import React from 'react';
import { COLORS } from '../../theme';

const VARIANTES = {
  primary: { bg: COLORS.primary, color: '#fff', border: 'none', shadow: '0 1px 4px rgba(29,107,240,0.25)' },
  secondary: { bg: COLORS.primary, color: '#fff', border: 'none', shadow: '0 1px 4px rgba(29,107,240,0.25)' },
  accent: { bg: '#d97706', color: '#fff', border: 'none', shadow: '0 1px 4px rgba(217,119,6,0.25)' },
  danger: { bg: '#ef4444', color: '#fff', border: 'none', shadow: '0 1px 4px rgba(239,68,68,0.20)' },
  ghost: { bg: COLORS.surface, color: COLORS.textMid, border: `1.5px solid ${COLORS.border}`, shadow: 'none' },
  warning: { bg: COLORS.warningBg, color: COLORS.warning, border: `1.5px solid ${COLORS.warning}40`, shadow: 'none' }
};

const TAMANHOS = {
  sm: { padding: '5px 14px', fontSize: 12 },
  md: { padding: '7px 18px', fontSize: 13 }
};

export default function Btn({ variante = 'primary', tamanho = 'md', children, style, disabled, ...props }) {
  const v = VARIANTES[variante] || VARIANTES.primary;
  const t = TAMANHOS[tamanho] || TAMANHOS.md;

  return (
    <button
      {...props}
      disabled={disabled}
      onMouseEnter={e => { if (!disabled) e.currentTarget.style.opacity = '0.85'; }}
      onMouseLeave={e => { e.currentTarget.style.opacity = '1'; }}
      style={{
        background: v.bg,
        color: v.color,
        border: v.border,
        boxShadow: v.shadow,
        borderRadius: 7,
        fontWeight: 600,
        letterSpacing: '0.01em',
        whiteSpace: 'nowrap',
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        transition: 'opacity .15s, box-shadow .15s',
        ...t,
        ...style
      }}
    >
      {children}
    </button>
  );
}
